export default __webpack_public_path__ + "static/media/e453e201122d7f77.7cf9d7f2ab32b9b2138c2863cc7badeb.svg";